import { SimpleGuard } from 'interfaces/guards'
import { GetTopAdvisorsAction, GetTopAdvisorsReviewsAction } from 'components/features/coaching/advisorStore/actions/advisorLandingPageActions'

export const topAdvisorsGuards: SimpleGuard = {
  name: `Top Advisors Guard`,
  checker: (state) => {
    const { advisors } = state.data
    return !!advisors.topAdvisors.data
  },
  loader: (dispatch) => {
    dispatch(new GetTopAdvisorsAction())
  },
}

export const topReviewGuards: SimpleGuard = {
  name: `Top Advisors Reviews Guard`,
  checker: (state) => {
    const { advisors } = state.data
    return !!advisors.topReviews.data
  },
  loader: (dispatch) => {
    dispatch(new GetTopAdvisorsReviewsAction())
  },
}
